import { initSwiper } from '../../components/swiper';

const initRelatedProducts = () => {
  const relatedProductsEls = document.querySelectorAll('[data-related-products]');
  if (!relatedProductsEls.length) return;

  const fetchResults = async (el, url) => {
    try {
      const response = await fetch(url);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const carouselEl = doc.querySelector('[data-related-products]');
      el.innerHTML = carouselEl.innerHTML;

      const sliderEl = el.querySelector('[data-swiper-related-products]');
      if (sliderEl) {
        const relatedProductsSwiper = initSwiper(sliderEl);
        window.theme.swiperObjects.push(relatedProductsSwiper);
      }
    } catch (err) {
      console.error('Error fetching related products:', err);
    }
  };

  relatedProductsEls.forEach(async (el) => {
    const productsUrl = await el.dataset.url;
    if (productsUrl) {
      await fetchResults(el, productsUrl);
    }
  });
};

export default initRelatedProducts;
